import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router";

import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";
import { history } from "../../../utils/chat/chatNavigation";

const QuestionExpiredSystemMessage = ({ showAskNewQuestionMessage }) => {
    const handleKeyPress = event => {
        if (event.charCode === 32 || event.charCode === 13) {
            history.push("/ask");
        }
    };
    return (
        <li>
            <div className="system-message message-question-closed-by-timeout">
                <div className="icon icon-checkmark">
                    <SvgIcon src={iconSprite} id="icon-checkmark" />
                </div>
                <p className="body">{i18n.t("rtm.text.question_marked_as_resolved")}</p>
            </div>
            <div className="system-message message-ask-new-question-after-expired">
                <div className="icon icon-speech-bubble">
                    <SvgIcon src={iconSprite} id="icon-speech-bubble" />
                </div>
                <p className="body">
                    {i18n.t("rtm.text.hope_you_got_the_help_part_1")}{" "}
                    {showAskNewQuestionMessage && (
                        <span>
                            {i18n.t("rtm.text.hope_you_got_the_help_part_2") + " "}
                            <Link to="ask" onKeyPress={handleKeyPress}>
                                <strong>{i18n.t("rtm.text.hope_you_got_the_help_part_3")}</strong>
                            </Link>
                            .
                        </span>
                    )}
                </p>
            </div>
        </li>
    );
};

QuestionExpiredSystemMessage.propTypes = {
    showAskNewQuestionMessage: PropTypes.bool.isRequired,
};

export default QuestionExpiredSystemMessage;
